// extracted by mini-css-extract-plugin
export default {"productDescription":"fca-z","featuredDescription":"gca-z","description":"hca-z","more":"ica-z","descriptionSku":"jca-z"};